import {
  AppBar,
  Avatar,
  Badge,
  Box,
  Container,
  Tab,
  Tabs,
  Toolbar,
  Tooltip,
  Typography,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Button,
} from "@mui/material";
import { Insights, Logout } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";

import CircleIcon from "@mui/icons-material/Circle";
import React, { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SVG from "../../Assests/SVG";
import ctmLogo from "../../Assests/Images/CtmMainImage.png";
import Grid from "@mui/material/Grid2";
import { deepOrange } from "@mui/material/colors";
import SideBarLayout from "./SideBarLayout";
import {
  MasterDataContextType,
  useMasterData,
} from "../../ContextAPI/MasterContext";
import {
  RecentInsights,
  useWasteManagement,
} from "../../ContextAPI/WasteManagementContext";
import AppColors from "../../Utils/AppColor";
import LogoImageSymbol from "../../Assests/SVG/LogoOnly.svg";
import LogoImageText from "../../Assests/SVG/LogoImageText.svg";
import { t } from "i18next";
import { AppRoutes } from "../../Routes/Layout/Routes";
import SenszLogo from "../../Assests/SVG/SenszLogo";
import { FetchSites, GetRecentInsights } from "../../ApiServices/ApiRequests";
import {
  DropDownOptions,
  MapResponseToDropdown,
  SitesInfo,
} from "../../Models/Models";
import { mapResponseToDropdown } from "../../Utils/CommonFunctions";

interface dataValue {
  state: boolean;
  data: string;
}

const SidebarWidth = "250px";
const ClosedSidebarWidth = "0px";

const MainLayout = () => {
  const { masterState, dispatchMaster } = useMasterData();
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem("LoginDetails") || "{}");
  const handleInputChange = useCallback(
    (
      field: keyof MasterDataContextType,
      value: boolean | string | DropDownOptions[] | RecentInsights[] | null
    ) => {
      dispatchMaster({ type: "SET_FIELD", field, value });
    },
    [dispatchMaster]
  );
  const [isHovered, setIsHovered] = React.useState<dataValue>({
    state: false,
    data: "",
  });

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [siteOptionsList, setSiteOptionsList] = useState<DropDownOptions[]>([]);
  const [selectedSiteCode, setSelectedSiteCode] = useState<string>();
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("LoginDetails");
    sessionStorage.clear();
    navigate("/");
  };

  interface activeTabs {
    label: string;
    value: string;
    role: "ADMIN" | "SUPER_ADMIN" | "USER";
    industry: string;
  }
  var tabsList: activeTabs[] = [
    {
      label: "Waste Management",
      value: "WASTE_MANAGEMENT",
      role: "SUPER_ADMIN",
      industry: "WasteManagement",
    },
  ];

  useEffect(() => {
    if (tabsList.length > 0) {
      handleInputChange("activeTab", tabsList[0].value);
    }
  }, []);
  useEffect(() => {
    getOrgId();

    tabsList.forEach((x) => {
      if ("WASTE_MANAGEMENT" == masterState.activeTab) {
        navigate(AppRoutes.WASTEDASHBOARDCTMLIVEOVERVIEW);
      }
    });
  }, [masterState.activeTab]);

  const getOrgId = () => {
    const value = sessionStorage.getItem("firstName");
    handleInputChange("firstName", value);
  };

  useEffect(() => {
    if (user?.organization[0]?.orgCode) {
      fetchSitesData(user?.organization[0]?.orgCode);
    }
  }, [user?.organization[0]?.orgCode]);
  const fetchSitesData = async (orgCode: string): Promise<void> => {
    try {
      handleInputChange("isloading", true);
      const data: SitesInfo[] = await FetchSites(orgCode);
      const sitesOptions: MapResponseToDropdown[] = mapResponseToDropdown(
        data,
        "siteName",
        "siteCode",
        "latitude",
        "longitude"
      );
      setSiteOptionsList(sitesOptions);
      if (siteOptionsList?.length > 0) {
        if (selectedSiteCode?.length == 0) {
          setSelectedSiteCode(siteOptionsList[0]?.value);
        }

        // handleInputChange("binPlottingmapCenter", {
        //   lat: parseFloat(sitesOptions[0]?.extraField1 ?? "0"),
        //   lng: parseFloat(sitesOptions[0]?.extraField2 ?? "0"),
        // });
      }
    } catch (error) {
      console.error("Error loading site Options data", error);
    } finally {
      handleInputChange("isloading", false);
    }
  };

  useEffect(() => {
    if (!!selectedSiteCode) {
      fetchRecentInsights(selectedSiteCode);
    }
  }, [selectedSiteCode]);

  const fetchRecentInsights = async (siteCode: string) => {
    try {
      const data = await GetRecentInsights(siteCode);
      handleInputChange("recentInsights", data);
    } catch (error) {
      console.error("error while mainlayout recent insights");
    }
  };

  const handleInputChangeMaster = useCallback(
    (field: keyof MasterDataContextType, value: boolean | string | null) => {
      dispatchMaster({ type: "SET_FIELD", field, value });
    },
    [dispatchMaster]
  );

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden"; // Prevent scrolling
    } else {
      document.body.style.overflow = ""; // Restore scroll
    }
    return () => {
      document.body.style.overflow = ""; // Clean up on unmount
    };
  }, [open]);

  const avatarContent = user?.image
    ? user.image
    : user?.firstName
    ? user.firstName[0]
    : "";

  return (
    <Box sx={{ display: "flex", bgcolor: "#f9f9f9", width: "100%" }}>
      <AppBar position="fixed">
        <Container maxWidth="xl" sx={{ background: "#FFFFFF" }}>
          <Toolbar disableGutters>
            <Box sx={{ width: "100vw" }}>
              <Grid container>
                <Grid
                  size={{ xs: 2, md: 2.1, sm: 2.1, lg: 2.1, xl: 2.1 }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    sx={{ p: 0 }}
                    onClick={() => {
                      handleInputChangeMaster(
                        "sidebaropen",
                        !masterState.sidebaropen
                      );
                    }}
                  >
                    <MenuIcon sx={{ color: "black", mr: "5px" }} />

                    <img
                      src={ctmLogo}
                      alt="CTM"
                      style={{ width: "100%", height: "60px" }}
                    />
                  </IconButton>
                </Grid>

                <Grid
                  size={5.9}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                ></Grid>
                <Grid
                  size={4}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    paddingTop: "1%",
                    paddingBottom: "1%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                      marginRight: "20px",
                      transition: "transform 0.2s ease",
                      transform:
                        isHovered.state && isHovered.data == "Insights"
                          ? "scale(1.05)"
                          : "scale(1)", // Scale effect on hover
                    }}
                    onClick={() => {
                      navigate(AppRoutes.DASHBOARDINSIGHTS);
                    }}
                    onMouseEnter={() =>
                      setIsHovered({ state: true, data: "Insights" })
                    }
                    onMouseLeave={() =>
                      setIsHovered({ state: false, data: "Insights" })
                    }
                  >
                    <Badge
                      badgeContent={masterState.recentInsights.length}
                      color="primary"
                    >
                      <SVG.MessageIcon />
                    </Badge>
                    <Typography variant="caption" color={AppColors.textGray}>
                      {t("global.insights")}
                    </Typography>
                  </div>

                  {/* <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                      transition: "transform 0.2s ease", // Smooth transition for scaling
                      transform:
                        isHovered.state && isHovered.data == "Notification"
                          ? "scale(1.05)"
                          : "scale(1)", // Scale effect on hover
                    }}
                    onMouseEnter={() =>
                      setIsHovered({ state: true, data: "Notification" })
                    }
                    onMouseLeave={() =>
                      setIsHovered({ state: false, data: "Notification" })
                    }
                  >
                    <Badge
                      badgeContent={masterState.recentActivities.length}
                      color="primary"
                    >
                      <SVG.NotificationBell />
                    </Badge>
                    <Typography variant="caption" color={AppColors.textGray}>
                      {t("global.Notification")}
                    </Typography>
                  </div> */}
                  {/* <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                      transition: "transform 0.2s ease", // Smooth transition for scaling
                      transform:
                        isHovered.state && isHovered.data == "Setting"
                          ? "scale(1.05)"
                          : "scale(1)", // Scale effect on hover
                    }}
                    onMouseEnter={() =>
                      setIsHovered({ state: true, data: "Setting" })
                    }
                    onMouseLeave={() =>
                      setIsHovered({ state: false, data: "Setting" })
                    }
                  >
                    <SVG.SettingsIcon />
                    <Typography variant="caption" color={AppColors.textGray}>
                      {t("global.Setting")}
                    </Typography>
                  </div> */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      transition: "transform 0.2s ease", // Smooth transition for scaling
                      transform:
                        isHovered.state && isHovered.data == "Profile"
                          ? "scale(1.05)"
                          : "scale(1)", // Scale effect on hover
                    }}
                    onMouseEnter={() =>
                      setIsHovered({ state: true, data: "Profile" })
                    }
                    onMouseLeave={() =>
                      setIsHovered({ state: false, data: "Profile" })
                    }
                  >
                    {" "}
                    <IconButton onClick={handleClick}>
                      <div>
                        <Avatar alt="User Name" src={avatarContent}>
                          {user?.image ? null : user?.firstName?.[0]}
                        </Avatar>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          marginLeft: "10%",
                          flexWrap: "nowrap",
                          whiteSpace: "nowrap", // Prevent text wrapping
                          width: "60px", // Adjust width to fit your content
                        }}
                      >
                        <Typography
                          color={AppColors.textGray}
                          sx={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                            overflowWrap: "break-word",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "100px",
                          }}
                          ml={3}
                        >
                          {masterState.firstName}
                        </Typography>
                        <Typography noWrap color="#32cd32">
                          <CircleIcon
                            sx={{
                              color: "#32cd32",
                              fontSize: "0.75rem",
                            }}
                          />{" "}
                          {t("global.Online")}
                        </Typography>
                      </div>
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      onClick={handleClose}
                    >
                      <MenuItem onClick={handleLogout}>
                        <ListItemIcon>
                          <Logout fontSize="small" />
                        </ListItemIcon>
                        {t("global.Logout")}
                      </MenuItem>
                    </Menu>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      <Box
        component="nav"
        className="scrollable-section"
        sx={{
          zIndex: 99,
          transition: "ease-in",
          width: `calc(100% - ${SidebarWidth}px)`,
        }}
      >
        <SideBarLayout />
      </Box>
      <Box
        className="scrollable-section"
        sx={{
          flexGrow: 1,
          height: "100vh",
          overflowY: "auto",
          paddingLeft: "20px",
          // paddingRight:"10px"
        }}
      >
        <Box sx={{ marginTop: "6%" }}></Box>
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
